import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({ providedIn: "root" })
export class NavigationService {
  constructor(private _router: Router) {}

  navigate(route: string, params?: string) {
    if (params) {
      this._router.navigate([route, params]);
    } else {
      this._router.navigate([route]);
    }
  }
}
